import { getContractsPrev } from 'core/services/workStoppage';
import { useQueryConf } from 'core/utils/useQuery';
import { useQuery } from 'react-query';

const fetchContractsPrev = async () => {
    const result = await getContractsPrev();
    return result;
};

export const useFetchContractsPrev = (user) => {
    return useQuery([user, 'contractsPrev'], () => fetchContractsPrev(), { ...useQueryConf });
};
